import _classCallCheck from "/jenkins/workspace/jenkins-non-prod-pipelines-LOS-UI-Login-UI-qa-11/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/jenkins/workspace/jenkins-non-prod-pipelines-LOS-UI-Login-UI-qa-11/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/jenkins/workspace/jenkins-non-prod-pipelines-LOS-UI-Login-UI-qa-11/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/jenkins/workspace/jenkins-non-prod-pipelines-LOS-UI-Login-UI-qa-11/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "/jenkins/workspace/jenkins-non-prod-pipelines-LOS-UI-Login-UI-qa-11/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/jenkins/workspace/jenkins-non-prod-pipelines-LOS-UI-Login-UI-qa-11/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/inherits";
import React, { Component } from 'react';
import { Column as RVColumn, Table as RVTable } from 'react-virtualized';
import CellMeasurerCache from 'react-virtualized/dist/commonjs/CellMeasurer/CellMeasurerCache';
import CellMeasurer from 'react-virtualized/dist/commonjs/CellMeasurer/CellMeasurer';
import defaultRowRenderer from 'react-virtualized/dist/commonjs/Table/defaultRowRenderer'; // import { hasPermission } from '@defi/core-auth';

import { Cell, HeaderCell, HeaderRow } from './';
import Auth from '@defi/core-auth';
import { List } from 'immutable';

var hasPermission = function hasPermission(permission) {
  return Auth.checkPermissions(List([permission]));
};

var DesktopTable =
/*#__PURE__*/
function (_Component) {
  _inherits(DesktopTable, _Component);

  function DesktopTable(props) {
    var _this;

    _classCallCheck(this, DesktopTable);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DesktopTable).call(this, props));
    _this.cache = new CellMeasurerCache({
      fixedWidth: true,
      minHeight: 40
    });
    _this.rowRenderer = _this.rowRenderer.bind(_assertThisInitialized(_this));
    _this.afterRowsRendered = _this.afterRowsRendered.bind(_assertThisInitialized(_this));
    _this.rvTable = null;
    return _this;
  }

  _createClass(DesktopTable, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.width !== this.props.width || prevProps.rows !== this.props.rows) {
        this.cache.clearAll();
      }

      this.rvTable.recomputeRowHeights(0);
    }
  }, {
    key: "renderBodyCell",
    value: function renderBodyCell(params) {
      var dataKey = params.dataKey,
          rowData = params.rowData,
          rowIndex = params.rowIndex,
          parent = params.parent;
      var col = rowData.getIn(['cell', dataKey]);
      var appId = rowData.get('id');
      var subId = rowData.get('subid');
      var link = this.props.link ? subId ? this.props.link(appId, subId) : this.props.link(appId) : false;
      var header = col ? col.get('header') : '';
      var value = col ? col.get('value') : '';
      return React.createElement(CellMeasurer, {
        cache: this.cache,
        columnIndex: dataKey,
        key: dataKey,
        parent: parent,
        rowIndex: rowIndex
      }, React.createElement(Cell, {
        header: header,
        link: link,
        appId: appId,
        rowData: rowData,
        index: rowIndex,
        custom: this.props.config.custom,
        colData: col
      }, value));
    }
  }, {
    key: "renderColumns",
    value: function renderColumns() {
      var _this2 = this;

      return this.props.children.get('headers').map(function (header, i) {
        var custom = _this2.props.config.custom ? _this2.props.config.custom.find(function (col) {
          return col.header === header.get('id');
        }) : false;

        if (custom && custom.permission) {
          if (!hasPermission(custom.permission)) {
            return null;
          }
        }

        var width = custom && custom.width ? custom.width : 2000;
        return React.createElement(RVColumn, {
          key: i,
          label: header.get('label'),
          dataKey: i,
          width: width,
          headerRenderer: function headerRenderer() {
            return React.createElement(HeaderCell, {
              onClick: _this2.props.setFilterCriteria,
              appId: header.get('id'),
              filterCriteria: _this2.props.filterCriteria
            }, header.get('label'));
          },
          cellRenderer: function cellRenderer(params) {
            return _this2.renderBodyCell(params);
          }
        });
      });
    }
  }, {
    key: "rowGetter",
    value: function rowGetter(_ref) {
      var index = _ref.index,
          list = _ref.list;
      return list.get(index);
    }
  }, {
    key: "rowRenderer",
    value: function rowRenderer(rowProps) {
      if (this.props.preRowRender && typeof this.props.preRowRender === "function") {
        rowProps = this.props.preRowRender(rowProps);
      }

      if (this.props.customRowRenderer && typeof this.props.customRowRenderer === 'function') {
        return this.props.customRowRenderer(rowProps);
      } else {
        return defaultRowRenderer(rowProps);
      }
    }
  }, {
    key: "afterRowsRendered",
    value: function afterRowsRendered() {}
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          width = _this$props.width,
          height = _this$props.height,
          rowHeight = _this$props.rowHeight;
      var list = this.props.rows;
      var adjustedHeight = height < 0 ? 120 * list.size : height;
      return React.createElement(RVTable, {
        ref: function ref(node) {
          return _this3.rvTable = node;
        },
        deferredMeasurementCache: this.cache,
        overscanRowCount: 2,
        height: adjustedHeight,
        rowGetter: function rowGetter(_ref2) {
          var index = _ref2.index;
          return _this3.rowGetter({
            index: index,
            list: list
          });
        },
        rowHeight: rowHeight ? rowHeight : this.cache.rowHeight,
        rowCount: list ? list.size : 0,
        width: width,
        headerHeight: 70,
        headerRowRenderer: function headerRowRenderer(params) {
          return React.createElement(HeaderRow, {
            params: params,
            width: width
          });
        },
        rowRenderer: this.rowRenderer,
        onRowClick: this.props.onRowClick,
        onRowsRendered: this.afterRowsRendered
      }, this.renderColumns(), React.createElement(RVColumn, {
        key: 1999999999,
        label: "",
        dataKey: 199999999,
        width: 200,
        headerRenderer: function headerRenderer() {
          return null;
        },
        cellRenderer: function cellRenderer() {
          return null;
        }
      }));
    }
  }]);

  return DesktopTable;
}(Component);

export default DesktopTable;